var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6 7H5.4C4.07452 7 3 8.07452 3 9.4V17.6C3 18.9255 4.07452 20 5.4 20H18.6C19.9255 20 21 18.9255 21 17.6V9.4C21 8.07452 19.9255 7 18.6 7Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 7V5.4C8.5 5.21615 8.53621 5.0341 8.60657 4.86424C8.67692 4.69439 8.78005 4.54005 8.91005 4.41005C9.04005 4.28005 9.19439 4.17693 9.36424 4.10657C9.5341 4.03621 9.71615 4 9.9 4H14.1C14.4713 4 14.8274 4.1475 15.0899 4.41005C15.3525 4.6726 15.5 5.0287 15.5 5.4V7",
    stroke: "#757575",
    strokeWidth: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDeals);
export default __webpack_public_path__ + "static/media/nav-deals.856dde2f18a772f564380aed9c66660b.svg";
export { ForwardRef as ReactComponent };